import { Box, TextFieldProps } from '@mui/material';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export type HtmlInputProps = Omit<TextFieldProps, 'variant' | 'error' | 'value' | 'onChange'> & {
  error?: string;
  value?: string;
  help?: string;
  icon?: React.ReactNode;
  onClear?: () => void;
  readonly?: boolean;
  onChange: (value: string) => void;
};

function convertFromHtml(text: string) {
  const blocksFromHtml = htmlToDraft(text);
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

  return EditorState.createWithContent(contentState);
}

function convertToHtml(editorState: EditorState) {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
}

export const HtmlEditor = (p: HtmlInputProps) => {
  const { error, value, help, label, onChange, onBlur, name } = p;
  const { $t } = useIntl();

  const [editorState, setEditorState] = useState(
    value ? convertFromHtml(value) : EditorState.createEmpty(),
  );

  return (
    <Box
      sx={{
        border: 1,
        borderColor: '#ddd',
        borderRadius: '6px',
        '& .editor': {
          px: 2,
          py: 1,
        },
        '& .public-DraftStyleDefault-block': {
          my: 1,
        },
        '& .rdw-editor-toolbar': {
          background: 'transparent',
          border: 'none',
          //borderBottom:  `1px solid ${appPalette.gray400}`,
        },
        a: {
          color: 'black',
        },
      }}
    >
      <Editor
        editorState={editorState}
        editorClassName="editor"
        stripPastedStyles
        onEditorStateChange={(newState) => {
          setEditorState(newState);
          onChange && onChange(convertToHtml(newState));
        }}
        onBlur={() => {
          onBlur &&
            onBlur({
              target: {
                name: name!,
              },
            } as any);
        }}
        toolbar={{
          options: ['fontSize', 'inline', 'blockType', 'textAlign', 'history'],
          inline: {
            options: ['bold', 'italic', 'underline', 'strikethrough'],
          },
        }}
        placeholder={$t({
          id: 'common.insertContentHere',
          defaultMessage: 'Insert content here',
        })}
      />
    </Box>
  );
};
